'use client';

import Icon from '@/components/ui/AppIcon';
import { useLanguage } from '@/contexts/LanguageContext';

const VisionSection = () => {
  const { language } = useLanguage();
  const isRTL = language === 'ar';

  const visionData = {
    ar: [
      {
        icon: 'EyeIcon',
        title: 'رؤيتنا',
        description: 'أن نكون من روّاد العمل القانوني في المملكة؛ نرتقي بخدماتنا عبر منهجية احترافية تضع العدالة والموثوقية في مقدمة أولوياتنا.'
      },
      {
        icon: 'RocketLaunchIcon',
        title: 'رسالتنا',
        description: 'تقديم خدمات قانونية دقيقة، مبنية على خبرة عملية ومعرفة متخصصة، مع متابعة مستمرة وشفافية تامة في كل إجراء.'
      },
      {
        icon: 'SparklesIcon',
        title: 'قيمنا',
        description: 'النزاهة، السرية التامة، المهنية، الالتزام، وتحقيق مصالح العميل بأفضل السبل القانونية.'
      }
    ],
    en: [
      {
        icon: 'EyeIcon',
        title: 'Our Vision',
        description: 'To be among the pioneers of legal work in the Kingdom; we elevate our services through a professional methodology that places justice and reliability at the forefront of our priorities.'
      },
      {
        icon: 'RocketLaunchIcon',
        title: 'Our Mission',
        description: 'Providing precise legal services based on practical experience and specialized knowledge, with continuous follow-up and complete transparency in every procedure.'
      },
      {
        icon: 'SparklesIcon',
        title: 'Our Values',
        description: 'Integrity, complete confidentiality, professionalism, commitment, and achieving client interests through the best legal means.'
      }
    ]
  };

  const items = visionData[language];

  return (
    <section data-component-id="src/app/landing-page/components/VisionSection.tsx:50:4" data-component-path="src/app/landing-page/components/VisionSection.tsx" data-component-line="50" data-component-end-line="87" data-component-file="VisionSection.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22id%22%3A%22vision%22%2C%22className%22%3A%22py-16%20bg-background%20relative%20overflow-hidden%22%7D"
      id="vision"
      className="py-16 bg-background relative overflow-hidden"
      dir={isRTL ? 'rtl' : 'ltr'}
    >
      <div data-component-id="src/app/landing-page/components/VisionSection.tsx:55:6" data-component-path="src/app/landing-page/components/VisionSection.tsx" data-component-line="55" data-component-end-line="86" data-component-file="VisionSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22container%20mx-auto%20px-4%20lg%3Apx-10%22%7D" className="container mx-auto px-4 lg:px-10">
        {/* Vision Cards Grid */}
        <div data-component-id="src/app/landing-page/components/VisionSection.tsx:57:8" data-component-path="src/app/landing-page/components/VisionSection.tsx" data-component-line="57" data-component-end-line="85" data-component-file="VisionSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20md%3Agrid-cols-3%20gap-6%20max-w-6xl%20mx-auto%22%7D" className="grid md:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {items.map((item, index) => (
            <div data-component-id="src/app/landing-page/components/VisionSection.tsx:59:12" data-component-path="src/app/landing-page/components/VisionSection.tsx" data-component-line="59" data-component-end-line="83" data-component-file="VisionSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22bg-card%20rounded-xl%20p-6%20shadow-card%20hover%3Ashadow-xl%20transition-all%20duration-300%20border%20border-border%20hover%3Aborder-accent%20hover%3Ascale-105%22%7D"
              key={index}
              className="bg-card rounded-xl p-6 shadow-card hover:shadow-xl transition-all duration-300 border border-border hover:border-accent hover:scale-105"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              {/* Icon */}
              <div data-component-id="src/app/landing-page/components/VisionSection.tsx:65:14" data-component-path="src/app/landing-page/components/VisionSection.tsx" data-component-line="65" data-component-end-line="72" data-component-file="VisionSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-14%20h-14%20bg-accent%2F10%20rounded-xl%20flex%20items-center%20justify-center%20mb-4%20mx-auto%22%7D" className="w-14 h-14 bg-accent/10 rounded-xl flex items-center justify-center mb-4 mx-auto">
                <Icon data-component-id="src/app/landing-page/components/VisionSection.tsx:66:16" data-component-path="src/app/landing-page/components/VisionSection.tsx" data-component-line="66" data-component-end-line="71" data-component-file="VisionSection.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22className%22%3A%22text-accent%22%7D"
                  name={item.icon as any}
                  size={28}
                  variant="solid"
                  className="text-accent"
                />
              </div>

              {/* Title */}
              <h3 data-component-id="src/app/landing-page/components/VisionSection.tsx:75:14" data-component-path="src/app/landing-page/components/VisionSection.tsx" data-component-line="75" data-component-end-line="77" data-component-file="VisionSection.tsx" data-component-name="h3" data-component-content="%7B%22elementName%22%3A%22h3%22%2C%22className%22%3A%22font-playfair%20font-bold%20text-xl%20text-primary%20mb-3%20text-center%22%7D" className="font-playfair font-bold text-xl text-primary mb-3 text-center">
                {item.title}
              </h3>

              {/* Description */}
              <p data-component-id="src/app/landing-page/components/VisionSection.tsx:80:14" data-component-path="src/app/landing-page/components/VisionSection.tsx" data-component-line="80" data-component-end-line="82" data-component-file="VisionSection.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22font-inter%20text-sm%20text-text-secondary%20leading-relaxed%20text-center%22%7D" className="font-inter text-sm text-text-secondary leading-relaxed text-center">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default VisionSection;